Dom.addComponent(new class AlertOverlayComponent extends AbstractComponent {

  constructor() {
    super({
      name: "alert-overlay",
      iframable: true,
      responsiveChildren: {
        width: false,
        height: false
      }
    });
  }

  css() {
    return `GULP-CSS-FILE-ALERT-OVERLAY`;
  }

  html(props) {
    return `
      <div class="slaask-hidden"></div>
    `;
  }

});
